import React from "react";
import PropTypes from "prop-types";
import Button from "../../Misc/Buttons/DefaultBlueButton";

var Rehearse = function Rehearse(_ref) {
  var onStart = _ref.onStart;
  return React.createElement("div", {
    className: "recorder__script-reherse"
  }, React.createElement("div", null, React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon",
    viewBox: "0 0 75 82",
    style: {
      height: "1em",
      width: "0.91463em"
    }
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3",
    transform: "translate(2 2)"
  }, React.createElement("path", {
    d: "M14.8546099,11.6222222 C26.2668191,23.3647594 43.8076082,26.866795 58.9037037,20.4166667"
  }), React.createElement("ellipse", {
    cx: "35.343",
    cy: "23.611",
    rx: "23.779",
    ry: "23.611"
  }), React.createElement("path", {
    d: "M70.6866824,77.7777778 C64.2229462,64.208505 50.4604182,55.555101 35.3433412,55.555101 C20.2262642,55.555101 6.46373627,64.208505 -8.52651283e-14,77.7777778"
  }))), React.createElement(Button, {
    onClick: onStart
  }, "Rehearse script")));
};

Rehearse.propTypes = process.env.NODE_ENV !== "production" ? {
  onStart: PropTypes.func.isRequired
} : {};
export default Rehearse;